export default __webpack_public_path__ + "static/media/012-knife.2ded3eb7.svg";